import {
  Dialog,
  DialogContent,
  DialogTitle,
  Icon,
  Typography,
} from "@mui/material";
import { StyledLightGreenButton } from "@Styled/Common";
import { styled } from "@mui/material/styles";
import { theme } from "@Definitions/Styled";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

interface IThankYouProps {
  handleClose: Function;
  isFormSubmitted: boolean;
}
const ThankYouMessage = ({ isFormSubmitted, handleClose }: IThankYouProps) => {
  return (
    <div>
      <BootstrapDialog
        onClose={() => handleClose()}
        aria-labelledby="customized-dialog-title"
        open={isFormSubmitted}
        maxWidth="xs"
      >
        <DialogTitle
          id="alert-dialog-title"
          style={{
            color: theme.palette.primary.main,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          Thank you
          <Icon component={PriorityHighIcon} />
        </DialogTitle>
        <DialogContent dividers>
          <Typography style={{ textAlign: "center", fontSize: "1rem" }}>
            We&apos;ve received your message and will get back to you within 24
            hours.
          </Typography>
          <StyledLightGreenButton
            style={{ margin: "1rem 10px 0 0", float: "right" }}
            onClick={() => handleClose()}
          >
            Ok
          </StyledLightGreenButton>
        </DialogContent>
      </BootstrapDialog>
    </div>
  );
};
export default ThankYouMessage;
